import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandHoldingHeart, faGraduationCap, faMedkit, faUsers } from '@fortawesome/free-solid-svg-icons';
import HeroSection from '../components/HeroSection';
import ContactSection from '../components/ContactSection';

const FoundationPage: React.FC = () => {
  return (
    <>
      <HeroSection 
        title="जीवन आधार फाउंडेशन"
        subtitle="आपल्या समाजात सकारात्मक बदल घडवण्यासाठी एकत्र येऊन काम करत आहोत"
        buttonText="सहभागी व्हा"
        buttonLink="#contact"
      />
      
      <section className="section">
        <Container>
          <Row className="align-items-center mb-5">
            <Col lg={6} className="mb-4 mb-lg-0">
              <h2>आमचे ध्येय</h2>
              <p className="lead">समाजाचे सक्षमीकरण आणि जीवनात सकारात्मक बदल</p>
              <p>
                जीवन आधार फाउंडेशन गरजूंना मदत करून समाजातील जीवन सुधारण्यासाठी कार्यरत आहे. 
                किशोर सलगर यांच्या नेतृत्वाखाली सुरू झालेल्या या संस्थेचे उद्दिष्ट म्हणजे समाजात सकारात्मक बदल घडवणे आणि मजबूत समुदाय निर्माण करणे.
              </p>
              <p>
                आमचा विश्वास आहे की प्रत्येक व्यक्तीला मूलभूत गरजा, दर्जेदार शिक्षण आणि आरोग्यसेवा मिळायला हवी. 
                विविध उपक्रमांद्वारे आम्ही वंचित व्यक्ती व कुटुंबांच्या जीवनात खऱ्या अर्थाने बदल घडवण्याचा प्रयत्न करतो.
              </p>
              <p>
                आमचे स्वयंसेवक व भागीदार मिळून समाजातील गरजा ओळखतात आणि शाश्वत उपाय राबवतात जे दीर्घकालीन परिणाम साधतात.
              </p>
            </Col>
            <Col lg={6}>
              <div className="bg-light-gray p-4 rounded">
                <h4 className="mb-4">आमचा प्रभाव</h4>
                <Row>
                  <Col md={6} className="mb-3">
                    <div className="d-flex">
                      <div className="me-3 text-primary">
                        <FontAwesomeIcon icon={faHandHoldingHeart} size="2x" />
                      </div>
                      <div>
                        <h5>समाजसेवा</h5>
                        <p className="mb-0">गरजूंना आवश्यक संसाधने उपलब्ध करून देणे</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="d-flex">
                      <div className="me-3 text-primary">
                        <FontAwesomeIcon icon={faGraduationCap} size="2x" />
                      </div>
                      <div>
                        <h5>शिक्षण</h5>
                        <p className="mb-0">वंचित मुलांसाठी शैक्षणिक उपक्रमांना मदत</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="d-flex">
                      <div className="me-3 text-primary">
                        <FontAwesomeIcon icon={faMedkit} size="2x" />
                      </div>
                      <div>
                        <h5>आरोग्य सेवा</h5>
                        <p className="mb-0">जे वैद्यकीय खर्च परवडू शकत नाहीत त्यांना मदत</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="d-flex">
                      <div className="me-3 text-primary">
                        <FontAwesomeIcon icon={faUsers} size="2x" />
                      </div>
                      <div>
                        <h5>सामाजिक कल्याण</h5>
                        <p className="mb-0">सामाजिक समस्यांवर उपाय करणारे उपक्रम</p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      
      <section className="section bg-light-gray">
        <Container>
          <h2 className="section-title">आमचे उपक्रम</h2>
          <p className="section-subtitle">समाजात बदल घडवण्यासाठीचा आमचा प्रयत्न</p>
          
          <Row className="g-4 mt-4">
            <Col lg={4} md={6}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>शैक्षणिक मदत</Card.Title>
                  <Card.Text>
                    वंचित मुलांना दर्जेदार शिक्षण मिळावे यासाठी आम्ही शालेय साहित्य, शिष्यवृत्ती आणि मार्गदर्शन कार्यक्रम राबवतो.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} md={6}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>आरोग्य शिबिरे</Card.Title>
                  <Card.Text>
                    ग्रामीण भागात आरोग्य तपासणी शिबिरे आयोजित करून प्राथमिक आरोग्यसेवा आणि जनजागृती केली जाते.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} md={6}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>महिला सक्षमीकरण</Card.Title>
                  <Card.Text>
                    महिलांना कौशल्य विकास, आर्थिक साक्षरता व उद्योजकतेद्वारे सशक्त करण्याचे कार्यक्रम.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} md={6}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>ग्रामीण विकास</Card.Title>
                  <Card.Text>
                    ग्रामीण भागातील पायाभूत सुविधा, स्वच्छता व पाण्याची उपलब्धता सुधारण्यासाठी उपक्रम.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} md={6}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>अन्न वितरण</Card.Title>
                  <Card.Text>
                    संकट काळात आणि नियमित वेळेस अन्न वाटप उपक्रम जेणेकरून कोणीही उपाशी राहू नये.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} md={6}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>पर्यावरण संवर्धन</Card.Title>
                  <Card.Text>
                    वृक्षारोपण आणि जनजागृती मोहीमेसह पर्यावरण रक्षणासाठी उपक्रम राबवले जातात.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      
      <ContactSection />
    </>
  );
};

export default FoundationPage;
